import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

// Composants
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import RealisationsSection from "./components/RealisationsSection";
import BeforeAfterSection from "./components/BeforeAfterSection";
import ServicesSection from "./components/ServicesSection";
import ContactSection from "./components/ContactSection";
import WhyChooseUs from "./components/WhyChooseUs";
import Footer from "./components/Footer";

// Page dynamique
import ServicePage from "./pages/ServicePage";

function HomePage() {
  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      const element = document.querySelector(hash);

      if (element) {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: "smooth",
          });
        }, 100);
      }
    }
  }, []);

  return (
    <div id="site-wrapper">
      <Navbar />

      <main
        style={{
          paddingTop: "3rem",
          maxWidth: "100%",
          overflowX: "hidden",
        }}
      >
        <section id="hero">
          <HeroSection />
        </section>

        <section id="about">
          <AboutSection />
        </section>

        <section id="realisations">
          <RealisationsSection />
        </section>

        <BeforeAfterSection />

        <section id="services">
          <ServicesSection />
        </section>

        <section id="whychooseus">
          <WhyChooseUs />
        </section>

        <section id="contact">
          <ContactSection />
        </section>

        <Footer />
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />

        <Route
          path="/services/:slug"
          element={<ServicePage />}
        />
      </Routes>
    </Router>
  );
}

export default App;